import { observer } from 'mobx-react-lite';
import type { ApplicationSdk } from '../core/sdk';
import { Button } from 'primereact/button';

const UnauthorizedPage = observer(({ sdk }: { sdk: ApplicationSdk }) => {
    const { customMessage } = sdk.customError || {};
    const isManagerOrAdmin = sdk.user?.isManager || sdk.user?.isAdmin || false;

    let defaultHintMessage = 'Wenn Sie nicht weiterkommen, schreiben Sie in den Chat "Menü".';

    if (isManagerOrAdmin) {
        defaultHintMessage = 'Laden Sie die Toolbox bitte neu, um fortzufahren.';
    }

    const errorTitle = customMessage?.title || 'Ihr Zugang ist abgelaufen';
    const errorMessage =
        customMessage?.text ||
        'Zur Sicherheit wird ihr Zugang nach einer Weile automatisch beendet.';
    const hintMessage = customMessage?.hint || defaultHintMessage;
    const errorLink = (!isManagerOrAdmin && customMessage?.link) || null;

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
                backgroundColor: '#f5f5f5',
                padding: '20px',
            }}
            data-testid="unauthorized-page"
        >
            <div
                style={{
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    padding: '40px 32px',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                    textAlign: 'center',
                    maxWidth: '400px',
                    width: '100%',
                }}
            >
                <div
                    style={{
                        marginBottom: '24px',
                    }}
                >
                    <div
                        style={{
                            width: '48px',
                            height: '48px',
                            backgroundColor: '#ff6b6b',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto 16px auto',
                        }}
                    >
                        <i
                            className="pi pi-exclamation-triangle"
                            style={{
                                fontSize: '24px',
                                color: 'white',
                            }}
                        ></i>
                    </div>
                    <h1
                        style={{
                            fontSize: '24px',
                            fontWeight: '600',
                            color: '#2c3e50',
                            margin: '0 0 16px 0',
                        }}
                        data-testid="unauthorized-title"
                    >
                        {errorTitle}
                    </h1>
                    <p
                        style={{
                            fontSize: '16px',
                            color: '#474b4bff',
                            lineHeight: '1.5',
                            margin: '0',
                        }}
                        data-testid="unauthorized-message"
                    >
                        {errorMessage}
                    </p>
                </div>
                {errorLink && (
                    <Button
                        label="Hier klicken zum Weitermachen"
                        icon="pi pi-refresh"
                        style={{
                            width: '100%',
                            backgroundColor: '#4CAF50',
                            borderColor: '#4CAF50',
                            color: 'white',
                            fontWeight: '600',
                            fontSize: '16px',
                            padding: '14px 24px',
                            borderRadius: '8px',
                            border: 'none',
                            marginBottom: '16px',
                        }}
                        onClick={() => window.open(errorLink)}
                    />
                )}
                {hintMessage && (
                    <>
                        <div
                            style={{
                                width: '100%',
                                height: '1px',
                                backgroundColor: '#e9ecef',
                                margin: '20px 0 16px 0',
                            }}
                        ></div>
                        <p
                            style={{
                                fontSize: '14px',
                                color: '#95a5a6',
                                margin: '0',
                                lineHeight: '1.4',
                            }}
                        >
                            {hintMessage}
                        </p>
                    </>
                )}
            </div>
        </div>
    );
});

export default UnauthorizedPage;
